module.exports = __webpack_public_path__ + "img/121ee8b04983a9e92f1f7a8c0ee4c48c.png";